<h1 id="title" class="title">Change password</h1>
<ngx-change-password-form></ngx-change-password-form>
<!-- <ngx-change-password ></ngx-change-password> -->
